import assetPositionsFactory from '../positions/asset-positions-factory';

import CashPosition from './cash-position';
import CashPositionDetails from './cash-position-details';

export default assetPositionsFactory({
  assetCategory: 'cash',
  RowComponent: CashPosition,
  ExpandedRowComponent: CashPositionDetails,
});
